/* Polsk katalog for locale-closing-cash-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'clo.cash.quickComments': 'Szybkie komentarze',
  'clo.cash.quickCountLabel': 'Przeliczone przez dyrektora zarządzającego',
  'clo.cash.quickCountText': 'Stan gotówki w kasie został fizycznie przeliczony na dzień 31.12.{{year}} przez dyrektora zarządzającego.',
  'clo.cash.quickSheetLabel': 'Arkusz inwentaryzacji zapisany',
  'clo.cash.quickSheetText': 'Podpisany arkusz inwentaryzacji kasy został sprawdzony i zapisany w teczce dokumentów.',
  'clo.cash.quickReportLabel': 'Sprawdzone z raportem kasowym',
  'clo.cash.quickReportText': 'Przeliczenie zostało sprawdzone z raportem kasowym na dzień 31.12.{{year}}.',
  'clo.cash.openPosting': 'Utwórz księgowanie ręczne',
  'clo.cash.postingTitle': 'Popraw stan gotówki',
  'clo.cash.postingDescription': 'Korekta po inwentaryzacji kasy {{year}}',
  'clo.cash.postingLoadError': 'Nie udało się wczytać księgowania ręcznego.',
  'clo.cash.postingSaved': 'Księgowanie zostało zaksięgowane. Sprawdź ponownie różnicę.',
});
